import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Trash } from 'react-bootstrap-icons';
import './Node.css';

const StarNode = ({ data, id }) => {
  // Define color schemes based on type
  const getColorClasses = (type) => {
    switch (type) {
      case 'mfd':
        return {
          container: 'round-node node-rounded-full node-border-yellow node-border-2',
          starContainer: 'node-star-container node-bg-yellow',
          text: 'node-text-gray',
          handle: 'node-handle node-handle-yellow'
        };
      case 'manager':
        return {
          container: 'round-node node-rounded-full node-border-blue-star node-border-2',
          starContainer: 'node-star-container node-bg-blue-star',
          text: 'node-text-gray',
          handle: 'node-handle node-handle-blue-star'
        };
      case 'saleshead':
        return {
          container: 'round-node node-rounded-full node-border-green-star node-border-2',
          starContainer: 'node-star-container node-bg-green-star',
          text: 'node-text-gray',
          handle: 'node-handle node-handle-green-star'
        };
      case 'branchhead':
        return {
          container: 'round-node node-rounded-full node-border-red-star node-border-2',
          starContainer: 'node-star-container node-bg-red-star',
          text: 'node-text-gray',
          handle: 'node-handle node-handle-red-star'
        };
      default:
        return {
          container: 'round-node node-rounded-full node-border-yellow node-border-2',
          starContainer: 'node-star-container node-bg-yellow',
          text: 'node-text-gray',
          handle: 'node-handle node-handle-yellow'
        };
    }
  };

  // Add console.log to debug the type being received
  console.log('StarNode type:', data.type);
  console.log('StarNode data:', data);

  const colors = getColorClasses(data.type || 'mfd');

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button */}
      <div 
        className={`delete-btn delete-btn.top-right ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      <div className={colors.starContainer}>
        <span className={`node-star-text ${colors.text}`}>
          {data.label || data.type}
        </span>
      </div>

      {/* Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className={colors.handle}
      />
    </div>
  );
};

export default StarNode; 